import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './app/App';
import { UserContextProvider } from './app/Context/UserContext';
import * as serviceWorker from './serviceWorker';
import '../src/assets/styles/poderosa.css'

ReactDOM.render(
  <BrowserRouter>
    <UserContextProvider>
      <App />
    </UserContextProvider>
  </BrowserRouter>
,document.getElementById('root'));

serviceWorker.unregister();